import React from 'react';
import { QuantityPicker } from 'ui';
import {
  changeQuantity,
  getListFlowQuantity,
  isListFlowShowingVariations,
} from '~/store/listFlow/slices/info';
import { useAppDispatch, useAppSelector } from '~/store/store';

interface Props {}

const ListFlowQuantityPicker: React.FC<Props> = () => {
  const dispatch = useAppDispatch();
  const quantity = useAppSelector(getListFlowQuantity);
  const showingVariations = useAppSelector(isListFlowShowingVariations);

  return (
    <QuantityPicker
      disabled={showingVariations}
      onChange={v => dispatch(changeQuantity(v))}
      value={quantity || ''}
    />
  );
};

export default ListFlowQuantityPicker;
